import React from 'react';

import { Block } from '../common/Block.jsx';
import * as Cell from '../common/Cell.jsx';
import { withHoverEffects } from '../common/Image.jsx';
import { default as InventoryHelper } from '../common/Inventory.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';
import Url from '../common/Url.jsx';

const SearchResultType = {
    Artist: 1,
    Blog: 2,
    Inventory: 0,
    Show: 3
}
function SearchResultCellContainer(props) {
    let link, type;
    switch (props.data.type) {
        case SearchResultType.Artist:
            if (props.data.artist) {
                link = `artist/${props.data.artist.artistId}`;
            }
            type = 'Artist';
            break;
        case SearchResultType.Blog:
            if (props.data.blog) {
                link = `post/${props.data.blog.blogId}`;
            }
            type = 'Blog';
            break;
        case SearchResultType.Inventory:
            if (props.data.inventory) {
                link = `art/${props.data.inventory.inventoryId}`;
            }
            type = 'Inventory';
            break;
        case SearchResultType.Show:
            if (props.data.show) {
                link = `show/${props.data.show.showId}`;
            }
            type = 'Show';
            break;
    }
    if (link) {
        link = Url.getLink('', link, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder)
    }
    const handleBlockProps = (d) => {
        if (!d || !d.type) {
            return {};
        }
        switch (d.type.value) {
            case Name.Block.SearchResult.Cell.Image[type]:
                return { defaultUrl: props.logoImageUrl };
            default:
                return {};
        }
    };
    let handleBuilderBlockProps;
    if (props.builder) {
        handleBuilderBlockProps = (d) => {
            if (!d.type) {
                return;
            }
            let image;
            switch (d.type.value) {
                case Name.Block.SearchResult.Cell.Image.Artist:
                    if (props.data.artist) {
                        image = props.data.artist.profile;
                    }
                    break;
                case Name.Block.SearchResult.Cell.Image.Blog:
                    if (props.data.blog) {
                        image = props.data.blog.featured;
                    }
                    break;
                case Name.Block.SearchResult.Cell.Image.Inventory:
                    if (props.data.inventory && props.data.inventory.images && props.data.inventory.images.length > 0) {
                        image = props.data.inventory.images[0];
                    }
                    break;
                case Name.Block.SearchResult.Cell.Image.Show:
                    if (props.data.show) {
                        image = props.data.show.image;
                    }
                    break;
                default:
                    return;
            }
            if (!image && d.config && d.config.layout && d.config.layout.maxHeight && d.config.layout.maxHeight.value && d.config.layout.maxHeight.value.length > 0) {
                return { style: { height: '100%' } };
            }
        }
    }
    return (
        <Cell.Container
            {...props}
            blockPropsHandler={handleBlockProps}
            builderBlockPropsHandler={handleBuilderBlockProps}
            link={link}
            type="searchResult" />
    );
}

// #region IMAGE

function _SearchResultImageComponent(props) {
    let imageStyle;
    let image = props.image || props.config.logo;
    if (props.blockConfig) {
        imageStyle = {};
        if (props.blockConfig.block) {
            Block.mapStyleConfigProps(imageStyle, props.blockConfig.block, (propName) => {
                switch (propName) {
                    case 'source':
                        return true;
                }
            });
        }
        if (props.blockConfig.layout) {
            Block.mapStyleConfigProps(imageStyle, props.blockConfig.layout, (propName) => {
                switch (propName) {
                    case 'height':
                    case 'hoverColor':
                    case 'hoverEffect':
                    case 'hoverScale':
                    case 'hoverZoom':
                    case 'maxHeight':
                    case 'width':
                        return true;
                }
            });
        }
    }
    return (
        <Cell.Image
            {...props}
            className="search__card__img"
            image={image}
            imageData={{ alt: props.title, title: props.title }}
            imageId={image && image.id}
            imageStyle={imageStyle} />
    );
}
const SearchResultImageComponent = withHoverEffects(_SearchResultImageComponent, 'layout')

function ArtistSearchResultImageComponent(props) {
    const data = props.data || {};
    let image = data.profile;
    if (props.blockConfig && props.blockConfig.block) {
        switch (props.blockConfig.block.source) {
            case 'cover':
                image = data.cover;
                break;
        }
    }
    return <SearchResultImageComponent {...props} image={image} title={data.name} />
}
const ArtistSearchResultImage = { Component: ArtistSearchResultImageComponent };

function BlogSearchResultImageComponent(props) {
    const data = props.data || {};
    return <SearchResultImageComponent {...props} image={data.featured} title={data.title} />
}
const BlogSearchResultImage = { Component: BlogSearchResultImageComponent };

function InventorySearchResultImageComponent(props) {
    const data = props.data || {};
    let image;
    if (data.images && data.images.length > 0) {
        image = data.images[0];
    }
    return <SearchResultImageComponent {...props} image={image} title={data.title} />
}
const InventorySearchResultImage = { Component: InventorySearchResultImageComponent };

function ShowSearchResultImageComponent(props) {
    const data = props.data || {};
    return <SearchResultImageComponent {...props} image={data.image} title={data.title} />
}
const ShowSearchResultImage = { Component: ShowSearchResultImageComponent };

// #endregion IMAGE

// #region ARTIST

function ArtistSearchResultMetaComponent(props) {
    const handleTokenReplacement = (keyword, options) => Token.parsing.artist({ artist: props.data, wrapContent: false }, keyword, options);
    return <Cell.Meta {...props} onTokenReplacement={handleTokenReplacement} />
}
const ArtistSearchResultMetaTokens = () => {
    return [
        Token.getWrappedTokenConfig('Artist Name', Token.ArtistName),
        Token.getWrappedTokenConfig('Artist Biography', Token.ArtistBiography),
        Token.getWrappedTokenConfig('Artist Lifespan', Token.ArtistLifespan)
    ];
}
const ArtistSearchResultMeta = { Component: ArtistSearchResultMetaComponent, Tokens: ArtistSearchResultMetaTokens };

// #endregion ARTIST

// #region BLOG

function BlogSearchResultMetaComponent(props) {
    const handleTokenReplacement = (keyword, options) => Token.parsing.blogContent({ blogContent: props.data }, keyword, options);
    return <Cell.Meta {...props} onTokenReplacement={handleTokenReplacement} />
}
const BlogSearchResultMetaTokens = () => {
    return [
        Token.getWrappedTokenConfig('Title', Token.Title),
        Token.getWrappedTokenConfig('Published Date', Token.Published),
        Token.getWrappedTokenConfig('Blog Excerpt', Token.Excerpt)
    ];
}
const BlogSearchResultMeta = { Component: BlogSearchResultMetaComponent, Tokens: BlogSearchResultMetaTokens };

// #endregion BLOG

// #region INVENTORY

function InventorySearchResultMetaComponent(props) {
    const edition = InventoryHelper.edition(props.data) || {};
    const handleTokenReplacement = (keyword, options) => Token.parsing.inventory(
        { edition, inventory: props.data, isArtist: props.isArtist, wrapContent: false },
        keyword,
        options
    );
    return <Cell.Meta {...props} onTokenReplacement={handleTokenReplacement} />
}
const InventorySearchResultMetaTokens = () => {
    return [
        Token.getWrappedTokenConfig('Artist Name', Token.ArtistName),
        Token.getWrappedTokenConfig('Title', Token.Title),
        Token.getWrappedTokenConfig('Edition Info', Token.Edition),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getWrappedTokenConfig('Medium', Token.Medium),
        Token.getWrappedTokenConfig('Dimensions', Token.Dimensions),
        Token.getWrappedTokenConfig('Alternate Dimensions', Token.AlternateDimensions),
        Token.getWrappedTokenConfig('Price', Token.Price)
    ];
}
const InventorySearchResultMeta = { Component: InventorySearchResultMetaComponent, Tokens: InventorySearchResultMetaTokens };

// #endregion INVENTORY

// #region SHOW

function ShowSearchResultMetaComponent(props) {
    const handleTokenReplacement = (keyword, options) => Token.parsing.show({ show: props.data, wrapContent: false }, keyword, options);
    return <Cell.Meta {...props} onTokenReplacement={handleTokenReplacement} />
}
const ShowSearchResultMetaTokens = () => {
    return [
        Token.getWrappedTokenConfig('Title', Token.Title),
        Token.getWrappedTokenConfig('Date', Token.Date),
        Token.getWrappedTokenConfig('Description', Token.Description)
    ];
}
const ShowSearchResultMeta = { Component: ShowSearchResultMetaComponent, Tokens: ShowSearchResultMetaTokens };

// #endregion SHOW

export {
    ArtistSearchResultImage,
    ArtistSearchResultMeta,
    BlogSearchResultImage,
    BlogSearchResultMeta,
    InventorySearchResultImage,
    InventorySearchResultMeta,
    SearchResultCellContainer,
    SearchResultType,
    ShowSearchResultImage,
    ShowSearchResultMeta
}